// 企微接口错误码查询 https://developer.work.weixin.qq.com/devtool/query?e=92002

import { error } from "console";

/**
 * 钉钉 SDK注册参数
 */
interface DDJSSDKConfig {
  timeStamp: number;
  timestamp: number;
  nonceStr: string;
  signature: string;
  corpId: string;
}
/**
 *
 * {"agentId":"1000016","timestamp":1742819184,"nonceStr":"sdgfpnukmyeggluo",
 * "signature":"79831e2d4443f7b62b97925ec81877f6b620f1ea",
 * "agentConfigSignature":"52b588f28eef22b0910d64574d7b072e063e268a",
 * "corpId":"wpyeRvdgAAO-G8d0c6w-4EHRP6dBEjNQ"}}
 * 企微 SDK注册参数
 */
interface WXJSSDKConfig {
  corpId: string; // 必填，企业微信的corpid，必须与当前登录的企业一致
  agentId: string; // 必填，企业微信的应用id （e.g. 1000247）
  suiteId?: string; // 当企业未安装应用时，可以通过授权应用的登录权限，获得某些接口的调用权限（e.g. 分享消息
  timestamp: number; // 必填，生成签名的时间戳
  nonceStr: string; // 必填，生成签名的随机串
  signature: string; // 必填，企业签名
  agentConfigSignature: string; // 应用签名
  suiteConfigSignature: string; // 当企业未安装应用时，可以通过授权应用的登录权限，获得某些接口的调用权限（e.g. 分享消息
}

/**
 * 移动端不太方便设置 header 方便测试同学测试，在提测阶段 hardcode 环境
 */
const debugHeader = {
  // 'x-tt-env': 'boe_bitable_jssdk'
  "x-tt-env": "boe_solo_jsparam",
};

export interface IJsSDK {
  // 当前会显露出来,尽量少用，看能否把接口都封装起来
  dd?: any;
  // 当前会显露出来,尽量少用，看能否把接口都封装起来
  ww?: any;
  //#region 判断当前环境
  isWxwork: () => boolean;
  isDingTalk: () => boolean;
  getDDConfig(): DDJSSDKConfig | undefined;
  getWWConfig(): WXJSSDKConfig | undefined;
  //#endregion

  //#region 功能相关
  // type 为 all、qrCode、barCode，默认是all。
  scan(
    type: string[],
    onSuccess?: (data: any) => void,
    onFail?: (err: any) => void
  ): void;

  setRight(
    show: boolean,
    control: boolean,
    text: string,
    onSuccess?: () => void
  ): void;
  //#endregion
}

/**
 * IJsSDK 的实现类，当前是通过类内部 if else 来屏蔽企微、钉钉的差异
 * 后续考虑实现两个子类
 */
class JsSDK implements IJsSDK {
  private isWw = false;
  private isDd = false;
  //{"timeStamp":"1741935049096","noncestr":"4phvpdktz5o","signature":"e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"}
  private ddConfig?: DDJSSDKConfig = undefined;
  private wwConfig?: WXJSSDKConfig = undefined;

  private _dd?: any;
  private _ww?: any;

  get dd() {
    return this._dd;
  }
  get ww() {
    return this._ww;
  }
  setIsWs(isWw: boolean) {
    this.isWw = isWw;
  }
  setIsDd(isDd: boolean) {
    this.isDd = isDd;
  }
  setDd(dd: any) {
    this._dd = dd;
  }
  setWw(ww: any) {
    this._ww = ww;
  }
  getDDConfig() {
    return this.ddConfig;
  }
  getWWConfig() {
    return this.wwConfig;
  }

  isDingTalk = () => this.isDd;
  isWxwork = () => this.isWw;

  /**
   * 获取钉钉的配置
   * 在初始化的时候调用
   * @returns
   */
  public async getDDConfigFromServer(): Promise<DDJSSDKConfig | undefined> {
    if (this.ddConfig) {
      return this.ddConfig;
    }
    const url = window.location.href;
    // const res = await fetch(`/api/ddsign?url=${encodeURIComponent(url)}`);
    const res = await fetch(
      `/space/api/bitable/solo/thridparty_jssdk_param?from=dd&url=${encodeURIComponent(
        url
      )}`,
      {
        headers: {
          ...debugHeader,
        },
      }
    );
    const resp = await res.json();
    if (resp.code === 0) {
      this.ddConfig = resp.data as DDJSSDKConfig;
    } else {
      alert("get dd config failed");
    }
    return this.ddConfig;
  }
  /**
   * 获取企业微信的配置
   * 在初始化的时候调用
   * @returns
   */
  public async getWxConfigFromServer(): Promise<WXJSSDKConfig | undefined> {
    if (this.wwConfig) {
      return this.wwConfig;
    }
    const url = window.location.href;
    // /space/api/bitable/solo/thridparty_jssdk_param?url=https%3A%2F%2Fnboe-cnwhd8s52d5.feishu-boe.cn
    // const res = await fetch(`/api/wxsign?url=${encodeURIComponent(url)}`);
    const res = await fetch(
      `/space/api/bitable/solo/thridparty_jssdk_param?from=ww&url=${encodeURIComponent(
        url
      )}`,

      {
        headers: {
          // TODO 移除调试代码
          ...debugHeader,
        },
      }
    );
    const resp = await res.json();
    if (resp.code === 0) {
      this.wwConfig = resp.data as WXJSSDKConfig;
    } else {
      alert("get weworker config failed");
    }

    return this.wwConfig;
  }

  //#region 功能相关接口
  /**
   * 发起扫码
   * @param type
   * @param onSuccess
   * @param onFail
   */
  scan(
    type: string[],
    onSuccess: (data: any) => void,
    onFail: (err: any) => void
  ) {
    if (this.isDd) {
      this.dd.biz.util.scan({
        type,
        onSuccess,
        onFail,
      });
    } else if (this.isWw) {
      // https://developer.work.weixin.qq.com/document/path/98600
      const res = this.ww
        .scanQRCode({
          needResult: true,
          scanType: type,
          success: (res: any) => {
            alert(`scanQRCode success${JSON.stringify(res)}`);
          },
          fail: (res: any) => {
            alert(`scanQRCode fail${JSON.stringify(res)}`);
          },
          complete: (res: any) => {
            alert(`scanQRCode complete${JSON.stringify(res)}`);
          },
          cancel: (res: any) => {
            alert(`scanQRCode cancel${JSON.stringify(res)}`);
          },
          error: (res: any) => {
            alert(`scanQRCode error${JSON.stringify(res)}`);
          },
        })
        .then((res: any) => {
          alert(`scanQRCode promise${JSON.stringify(res)}`);
        }).catch((res:any)=>{
          alert(`scanQRCode catch${JSON.stringify(res)}`);
        });

        res.then((data:any)=>{
          alert(`scanQRCode then2${JSON.stringify(data)}`);
        })
    }
  }

  setRight(
    show: boolean,
    control: boolean,
    text: string,
    onSuccess?: () => void
  ): void {
    if (this.isDd) {
      this.dd.biz.navigation.setRight({
        show, //控制按钮显示， true 显示， false 隐藏， 默认true
        control, //是否控制点击事件，true 控制，false 不控制， 默认false
        text, //控制显示文本，空字符串表示显示默认文本
        onSuccess, //点击成功的回调
      });
    } else if (this.ww) {
      this.ww.hideOptionMenu();
    }
  }
  //#endregion
}
let jsSDK: IJsSDK | undefined = undefined;
/**
 * 同步获取IJsSDK接口
 * @returns IJsSDK 如果还没有初始化可能为空
 */
export const getJsSDK = () => {
  return jsSDK;
};

/**
 * 注册 SDK，初始化的时候会调用
 * 另外在 URL变化的时候，SDK 不需要重新初始化，但是需要重新注册
 * @returns
 */
export const registerSdk = async () => {
  if (jsSDK && jsSDK.isWxwork() && jsSDK instanceof JsSDK) {
    const config = await jsSDK.getWxConfigFromServer();
    if (!config) {
      alert("wework jssdk register get config failed");
      return;
    }
    const getConfigSignature = (url: string) => {
      // 根据 url 生成企业签名
      // 生成方法参考 https://developer.work.weixin.qq.com/document/14924
      return {
        /**
         * 生成签名的时间戳
         */
        timestamp: config.timestamp,
        /**
         * 生成签名的随机串
         */
        nonceStr: config.nonceStr,
        /**
         * 签名
         */
        signature: config.signature,
      };
    };
    const getAgentConfigSignature = (url: string) => {
      // 根据 url 生成应用签名，生成方法同上，但需要使用应用的 jsapi_ticket
      const agentConfig = {
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.agentConfigSignature,
      }
      alert('getAgentConfigSignature'+JSON.stringify(url));
      return agentConfig;
    };
    const getSuiteConfigSignature = (url: string) => {
      // 根据 url 生成应用签名，生成方法同上，但需要使用应用的 jsapi_ticket
      return {
        /**
         * 生成签名的时间戳
         */
        timestamp: config.timestamp,
        /**
         * 生成签名的随机串
         */
        nonceStr: config.nonceStr,
        /**
         * 签名
         */
        signature: config.suiteConfigSignature,
      };
    };
    jsSDK.ww.register({
      corpId: config?.corpId,
      //agentId: config.agentId,
      getConfigSignature,
      // getAgentConfigSignature,
      getSuiteConfigSignature,
      jsApiList: ["scanQRCode", "getExternalContact", "hideOptionMenu"],
      onConfigSuccess: (res: any) => {
        alert("onConfigSuccess");
      },
      onConfigFail: function (res: any) {
        alert("onConfigFail" + JSON.stringify(res));
      },
      onAgentConfigSuccess: (res: any) => {
        alert("onAgentConfigSuccess");
      },
      onAgentConfigFail: function (res: any) {
        alert("onConfigFail" + JSON.stringify(res));
      },
    });
  } else if (jsSDK && jsSDK.isDingTalk() && jsSDK instanceof JsSDK) {
    const config = await jsSDK.getDDConfigFromServer();
    if (!config) {
      alert("dd jssdk register get config failed");
      return;
    }
    // alert("dd registerSdk config:"+JSON.stringify(config));
    jsSDK.dd.config({
      corpId: config.corpId,
      nonceStr: config.nonceStr,
      signature: config.signature,
      // 适配后端参数名小写
      timeStamp: config.timeStamp || config.timestamp,
      // 钉钉历史文档 https://open.dingtalk.com/document/orgapp/jsapi-overview
      // 这个 list 不添加注册似乎也没有问题
      jsApiList: [
        "biz.contact.choose",
        "biz.util.sca",
        "dd.biz.navigation.setTitle",
        "setNavigationTitle",
        "quitPage",
        "chooseStaffForPC",
      ],
    });

    jsSDK.dd.error((err: any) => {
      alert("dd error: " + JSON.stringify(err) + JSON.stringify(config));
      // console.error("dd error: ", err);
    }); //该方法必须带上，用来捕获鉴权出现的异常信息，否则不方便排查出现的问题

    jsSDK.dd.ready(function () {
      alert("dd ready!!");
    });
  }
};

/**
 * 异步初始化 JSSDK
 * @param force 是否强制重新初始化
 * @returns
 */
export const initJssdkAsync = async (
  force: boolean = false
): Promise<IJsSDK> => {
  return new Promise<IJsSDK>(async (resolve) => {
    if (!force && jsSDK) {
      resolve(jsSDK);
      return;
    }
    const ua = window.navigator.userAgent;
    const searchParams = new URLSearchParams(window.location.search);
    const from = searchParams.get("from");
    const jsSDKObj = new JsSDK();
    jsSDK = jsSDKObj;
    if (from === "wx" || /wxwork/.test(ua)) {
      const ww = await import("@wecom/jssdk");
      window.ww = ww;
      jsSDKObj.setIsWs(true);
      jsSDKObj.setWw(ww);
    } else if (from === "dd" || /DingTalk/.test(ua)) {
      const dd = await import("dingtalk-jsapi");
      window.dd = dd;
      jsSDKObj.setIsDd(true);
      jsSDKObj.setDd(dd);
    }
    await registerSdk();
    resolve(jsSDKObj);
  });
};
